<template>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="containerItem2">
				<div class="top">
					<a class="img" :href="item.href" :style='`background-image: url(${item.img})`'>
						<!-- <img :src="item.img" alt=""> -->
					</a>
				</div>
				<div class="text">
					<a :href="item.href">
						<b>{{item.text}}</b>
					</a>
				</div>
				<div class="bottom">
					<div class="time">
						<span>
							<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="17" viewBox="0 0 16 17"> <metadata><?xpacket begin="﻿" id="W5M0MpCehiHzreSzNTczkc9d"?> <x:xmpmeta xmlns:x="adobe:ns:meta/" x:xmptk="Adobe XMP Core 5.6-c142 79.160924, 2017/07/13-01:06:39 "> <rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"> <rdf:Description rdf:about=""/> </rdf:RDF> </x:xmpmeta> <?xpacket end="w"?></metadata> <image id="icons8-time" width="16" height="17" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAMAAADjcdz2AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA/FBMVEVESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk5ESk4AAAAEhMBKAAAAUnRSTlMAIfb7/PdqiodoExV9sdDLrHgRueVmnp/RZcbMeqcg+GdXTIWII9Pd2O9EP1nNCT6UATzZe46vb1qjGeLkKh0MHw8Okzg6kc5Nw2QzxMUIYuZheZRjHgAAAAFiS0dEU3pnHQYAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfhCxsRGh0vy9xNAAAAwklEQVQY002P11ICURBEG1gEhSXnIFFAJIjkoCRJuwTp//8YdxYo6IfpPj1Tt+oCIovVptgteNCTw/ksi5cLutyqx+vzBxAMuYTDpCcSjZHxBJMGp5g2L19VZrI5IM/C7aUi34xpLUEtX5vKO1DlB2qsN8yiyiY+2QK+2O5I1WIXPbus+uRAPOPDUJEwGk++xZUhsvyRNJ3KnDGOOSP3H0S5AJb8vfGKa7EN8xfesm56I8Gdpuvanofj9fT0R0Ohs+R/wXcaDJiUt84AAAAASUVORK5CYII="/> </svg>
						</span>
						<span>
							{{item.time}}
						</span>
					</div>
					<a :href="item.href" class="button">
						{{item.button}}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 2 ? true : false,
				nav: true,
				dots: false,
				margin: 35,
				responsive: {
					0: {
						items: 1,
					},
					768: {
						items: 2,
					}
				}
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.slider-lowCost2 {
	margin-bottom: 7px;
		b{
			font-weight: 900;
		}
		.owl-carousel {
			position: relative;
			padding: 0 2px 2px 2px;
			.owl-stage-outer{
				padding: 0 1px;
			}
			.item {
				.containerItem2{
					border: 1px solid #e2edf3;
					box-shadow: 0px 0px 2px #e2edf3;
					border-radius: 6px;
					margin: 1px;
					.img{
						width: 100%;
						height: 134px;
						border-radius: 5px 5px 0px 0px;
            background-position: center;
            // background-size: cover;
						background-size: contain;
						background-position: center;
						background-repeat: no-repeat;
						border-bottom: 1px solid #e2edf3;
            // background-image: darkgrey;
					}
					.top{
						display: flex;
						justify-conent: center;
						align-items: center;
						overflow: hidden;
					}
					.text{
						padding-top: rem(26);
						padding-left: rem(30);
						padding-right: rem(30);
						height: rem(70);
						overflow: hidden;
						a{
							color: black;
							text-decoration: none;
							// text-decoration-color:
							line-height: rem(22);
							&:hover{
								text-decoration: underline;
							}
						}
					}
					.bottom{
						padding-bottom: rem(30);
						display: flex;
						justify-content: space-between;
						margin-top: 23px;
						align-items: center;
						&:after{
							content: "";
							width: 98%;
							position: absolute;
							top: -2px;
							left: 3px;
							right: 0;
							height: 2px;
							background: #fff;
						}
					}
					.time{
						display: flex;
						align-items: center;
						margin-left: rem(30);
						position: relative;
						font-size: rem(12);
						color: #444a4e;
						justify-content: space-between;
						padding-right: rem(10);
						@include l___up{
							font-size: rem(15);
						}
						@include s__only{
							font-size: rem(13);
						}
						@include s___only{
							font-size: rem(15);
						}
						span{
							&:nth-child(2){
								/*white-space: nowrap;*/
								margin-left: 10px;
							}
						}
					}
					.button{
						margin-right: rem(30);
						@include l_only {
							padding: 0 20px;
							min-height: 35px;
							font-size: rem(13);
						}
					}
				}
			}
			.owl-nav{
				font-size: 0;
				display: flex;
				justify-content:space-between;
				width: 100px;
				position: absolute;
				right: 0;
				bottom: -60px;
		        top: auto;
				z-index: 11;
				@include m_up{
					/*top: calc(50% - 21px);*/
					top: 50%;
					transform: translateY(-50%);
					bottom: auto;
					width: 100%;
				};
				.owl-prev{
					bottom: 0px;
					transform: rotate(90deg);
					position: relative;
					left: 0;
					@include m_up{
						left: -68px;
					};
				}
				.owl-next{
					bottom: 0px;
					transform: rotate(-90deg);
					position: relative;
					right: 0;
					@include m_up{
						right: -68px;
					};
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// otherStock.vue?6a834172